import type { ImportConflictChoice } from '../utils/import/core'
import { useConfirmDialog } from './ui/useConfirmDialog'

export function useImportConflictDialog() {
  const { confirm, DialogComponent } = useConfirmDialog<ImportConflictChoice>()

  function showDialog(parameters: {
    filename: string
    isCalendarFile: boolean
  }): Promise<{ choice: ImportConflictChoice; remember: boolean }> {
    const { filename, isCalendarFile } = parameters

    const title = isCalendarFile
      ? 'Calendar Note Already Exists'
      : 'Note Already Exists'

    const message = isCalendarFile ? (
      <>
        The calendar note &apos;{filename}&apos; already exists. What would you
        like to do?
      </>
    ) : (
      <>
        The note &apos;{filename}&apos; already exists. What would you like to
        do?
      </>
    )

    const actions = isCalendarFile
      ? [
          { id: 'skip' as const, label: 'Skip', intent: 'primary' as const, autoFocus: true },
          {
            id: 'overwrite' as const,
            label: 'Overwrite',
            intent: 'danger' as const,
          },
        ]
      : [
          {
            id: 'duplicate' as const,
            label: 'Create Duplicate',
            intent: 'primary' as const,
            autoFocus: true,
          },
          { id: 'skip' as const, label: 'Skip', intent: 'default' as const },
          {
            id: 'overwrite' as const,
            label: 'Overwrite',
            intent: 'danger' as const,
          },
        ]

    return confirm({
      title,
      message,
      actions,
      checkboxLabel: "Don't ask again for this import",
    }).then(({ actionId, remember }) => ({ choice: actionId, remember }))
  }

  return { showDialog, DialogComponent }
}
